import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import { css } from '@emotion/react';

function ItemFooterSkeleton() {
    return (
        <Column fullWidth spacing={20}>
            <Row fullWidth justify='space-between'>
                <Skeleton width={120} height={22} />
                <Skeleton width={82} height={30}/>
            </Row>
            <Row fullWidth spacing={8}>
                <Skeleton width={0} height={56} css={css`flex: 1`} radius={20}/>
                <Skeleton width={0} height={56} css={css`flex: 1`} radius={20}/>
            </Row>
        </Column>
    );
}

export default ItemFooterSkeleton;
